import {useState, useRef} from 'react'
import {Form, FormControl} from 'react-bootstrap'

const InText = ({name,value,label,type,size,onChange,readOnly=false}) => {

    return (
        <Form.Group controlId={`InText-${name}`} className='form-row conter'>
            
            <Form.Control
            className={ (name==='code') ? 'col-sm-9 text-center' : (name==='Phone')?'col-sm-12 text-center':'col-sm-12 text-right' }
            type={type ?? 'text'}
            name={name}                
            placeholder={label ?? name}
            defaultValue={value}
            style={{fontSize:size??'1.5rem', fontWeight:'bold', color:'blue', margin:'1rem 0 1rem 0'}}               
            readOnly={readOnly}
            onChange={onChange}
            //  required
            />
            {/*<Form.Label className='col-sm-2' align='right'>:{label ?? name}</Form.Label>*/}
        </Form.Group>        
    )
}

const InDetail = ({name,value,label,readOnly,size,onChange}) => {

    return (
        <Form.Group controlId={`InDetail-${name}`} className='form-row conter' width='100%'>
            <textarea className="form-control text-right" rows="2" 
                name={name} 
                type="text"
                style={{fontSize:size??'1.5rem', marginTop:'1rem'}}
                defaultValue={value ??''} 
                align='right'
                placeholder={label ?? name}
                readOnly={readOnly??false}  
                onChange={onChange}          
            />
        </Form.Group>
    )
}

/*
In React, components need to be capitalized !
*/
const InCheck = (name, value=false, mode=0, label) => {
    const [checked, setChecked] = useState(value)
    return (
        <div className="form-group form-row">
      <label className="control-label col-sm-2" style={{width:"auto", textAlign:"right"}}>
          {label ?? name}: </label>
          <div className="col-sm-1">
            <input type="checkbox" name={name}
            defaultChecked={checked}
            onChange={() => setChecked(!checked)}
            readOnly={(mode??0)===0}
            className="form-control" 
            />        
        </div>
      </div>     
    )
}

const SearchControl = ({onSearch}) => {
    //const searched = useRef("") 
    const [showing, Showing] = useState(false)
    const search = useRef("")

    const onChange = (e) => {
        onSearch(e.target.value)
        search.current=e.target.value
    }

    const onClick = (e) => {
        if(showing) {
            onSearch(search.current)
        }
        Showing(!showing)
    }

    return (
        <>
                        
        <i className="fa fa-search" style={{ fontSize:'1rem'}} onClick={onClick} ></i>

        { showing ?       
            <FormControl 
                className="d-inline" 
                style={{ textAlign: 'left', backgroundColor:'lightblue', width:"5rem", fontSize:'1.2rem' }} 
                name="Search" type="text" 
                defaultValue=""
                onChange={onChange}
                placeholder="" />
        : null }

        </>
    )
}


const TextControl = ({name,value,mode,type,onChange}) => {

    return (
        <Form.Group controlId={name} className='form-row' style={{marginBottom:'6px'}}>
                <Form.Label className='col-sm-3' >{name} :</Form.Label>
                <Form.Control
                className='col-sm-9'
                type={type ?? 'text'}
                name={name}                
                placeholder={name}
                fontSize='1.5rem'
                //value={value}
                defaultValue={mode===2?"":value}                
                readOnly={mode===0}
                onChange={onChange}
                //  required
                />
            </Form.Group>        
    )
}

const InOption = ({entity='Control', options, selected=1, onChange, readOnly=false, title}) => {
    const id=`Option-${entity}` 
    const [value, Value] = useState(selected??1)

    const onSelect=(e) =>{
        if(e?.target) {
            onChange && onChange(e)
            if(!readOnly && e.target.value>0 && value!==e.target.value) {
                Value(e.target.value)
            }
        }
    }
 
    return (
            <Form.Control as="select" id={id} key={id} className="text-right" 
                onChange={onSelect} 
                value={value}
                title={title ?? id}
                readOnly={readOnly} 
                disabled={readOnly} 
                style={{color:'silver', height:'2rem',backgroundColor:'transparent'}}
                
                >
                {
                    Array.isArray(options) && options.map(item => 
                    <option id={`${id}-${item.Id}`} key={`${id}-${item.Id}`} 
                    value={item.Id}
                    style={{backgroundColor:'transparent'}}
                    >{item.Value}</option>
                    )
                }
            </Form.Control> 
        
    )
}

export {InText, InDetail, InCheck, TextControl, SearchControl, InOption}
